/**
 *
 * @module entry
 * @desc {SDK.Services.Commerce} entry point.
 *
 */

import CommerceClient from './commerceClient';
import CommerceClientConfiguration from './commerceClientConfiguration';
import CommerceClientEndpoint from './commerceClientEndpoint';
import CommerceClientExtrasMap from './commerceClientExtrasMap';

import Address from './address';
import AddressableCreditCard from './addressableCreditCard';
import AffiliateTracking from './affiliateTracking';
import AmountedLineItem from './amountedLineItem';
import AppAccount from './appAccount';
import BillingAddress from './billingAddress';
import CallbackUrl from './callbackUrl';
import CreatePaymentMethodPassthroughData from './createPaymentMethodPassthroughData';
import CreatePaymentMethodRequest from './createPaymentMethodRequest';
import CreatePaymentMethodResponse from './createPaymentMethodResponse';
import CreditCard from './creditCard';
import CreditCardType from './creditCardType';
import Currency from './currency';
import GuidGeneratorResponse from './guidGeneratorResponse';
import LineItem from './lineItem';
import LineItemAttribute from './lineItemAttribute';
import Locale from './locale';
import OrderCampaign from './orderCampaign';
import OrderItem from './orderItem';
import OrderStatusResponse from './orderStatusResponse';
import OrderSubmissionEnvironment from './orderSubmissionEnvironment';
import PassThroughData from './passThroughData';
import PaymentCardType from './paymentCardType';
import PaymentMethodResponse from './paymentMethodResponse';
import PaymentMethodType from './paymentMethodType';
import Price from './price';
import PriceOrderRequest from './priceOrderRequest';
import PriceOrderRequestAddress from './priceOrderRequestAddress';
import PriceOrderResponse from './priceOrderResponse';
import RedemptionRequest from './redemptionRequest';
import Sku from './sku';
import SubmitOrderRequest from './submitOrderRequest';
import SubmitOrderWithPaymentMethodError from './submitOrderWithPaymentMethodError';
import SubmitOrderWithPaymentMethodRequest from './submitOrderWithPaymentMethodRequest';
import SubmitOrderWithPaymentMethodResponse from './submitOrderWithPaymentMethodResponse';
import ZipLocation from './zipLocation';

/**
 *
 * @typedef SDK.Services.Commerce
 * @type {Object}
 *
 * @property {CommerceClient} CommerceClient
 * @property {CommerceClientConfiguration} CommerceClientConfiguration
 * @property {CommerceClientEndpoint} CommerceClientEndpoint
 * @property {CommerceClientExtrasMap} CommerceClientExtrasMap
 *
 * @property {Address} Address
 * @property {AddressableCreditCard} AddressableCreditCard
 * @property {AffiliateTracking} AffiliateTracking
 * @property {AmountedLineItem} AmountedLineItem
 * @property {AppAccount} AppAccount
 * @property {BillingAddress} BillingAddress
 * @property {CallbackUrl} CallbackUrl
 * @property {CreditCard} CreditCard
 * @property {CreatePaymentMethodPassthroughData} CreatePaymentMethodPassthroughData
 * @property {CreatePaymentMethodRequest} CreatePaymentMethodRequest
 * @property {CreatePaymentMethodResponse} CreatePaymentMethodResponse
 * @property {CreditCardType} CreditCardType
 * @property {Currency} Currency
 * @property {GuidGeneratorResponse} GuidGeneratorResponse
 * @property {LineItem} LineItem
 * @property {LineItemAttribute} LineItemAttribute
 * @property {Locale} Locale
 * @property {OrderCampaign} OrderCampaign
 * @property {OrderItem} OrderItem
 * @property {OrderStatusResponse} OrderStatusResponse
 * @property {OrderSubmissionEnvironment} OrderSubmissionEnvironment
 * @property {PassThroughData} PassThroughData
 * @property {PaymentMethodResponse} PaymentMethodResponse
 * @property {PaymentCardType} PaymentCardType
 * @property {PaymentMethodType} PaymentMethodType
 * @property {Price} Price
 * @property {PriceOrderRequest} PriceOrderRequest
 * @property {PriceOrderRequestAddress} PriceOrderRequestAddress
 * @property {PriceOrderResponse} PriceOrderResponse
 * @property {RedemptionRequest} RedemptionRequest
 * @property {Sku} Sku
 * @property {SubmitOrderRequest} SubmitOrderRequest
 * @property {SubmitOrderWithPaymentMethodError} SubmitOrderWithPaymentMethodError
 * @property {SubmitOrderWithPaymentMethodRequest} SubmitOrderWithPaymentMethodRequest
 * @property {SubmitOrderWithPaymentMethodResponse} SubmitOrderWithPaymentMethodResponse
 * @property {ZipLocation} ZipLocation
 *
 */

/**
 *
 * @type {SDK.Services.Commerce}
 *
 */
export default {

    CommerceClient,
    CommerceClientConfiguration,
    CommerceClientEndpoint,
    CommerceClientExtrasMap,

    Address,
    AddressableCreditCard,
    AffiliateTracking,
    AmountedLineItem,
    AppAccount,
    BillingAddress,
    CallbackUrl,
    CreatePaymentMethodPassthroughData,
    CreatePaymentMethodRequest,
    CreatePaymentMethodResponse,
    CreditCard,
    CreditCardType,
    Currency,
    GuidGeneratorResponse,
    LineItem,
    LineItemAttribute,
    Locale,
    OrderCampaign,
    OrderItem,
    OrderStatusResponse,
    OrderSubmissionEnvironment,
    PassThroughData,
    PaymentCardType,
    PaymentMethodResponse,
    PaymentMethodType,
    Price,
    PriceOrderRequest,
    PriceOrderRequestAddress,
    PriceOrderResponse,
    RedemptionRequest,
    Sku,
    SubmitOrderRequest,
    SubmitOrderWithPaymentMethodError,
    SubmitOrderWithPaymentMethodRequest,
    SubmitOrderWithPaymentMethodResponse,
    ZipLocation

};



// WEBPACK FOOTER //
// ./src/services/commerce/entry.js